import React, { Component } from 'react';
import '../estilos/Header.css';

export default class Header extends Component {
  render() {
    return (
      <header className="top__header">
        <h1>Sistema Solar</h1>
      </header>
    );
  }
}
